import './index.less';
import React from 'react';
import { Button, Rate, Input, Message } from 'antd';
import { evaluate } from '../../api/index.js';

const { TextArea } = Input;
const name = {
  0: {
    name: '课程满意度',
    type: 'total'
  },
  1: {
    name: '老师满意度',
    type: 'teacher'
  },
  2: {
    name: '平台满意度',
    type: 'network'
  },
  3: {
    name: '教材满意度',
    type: 'classware'
  }
}

class Evaluate extends React.Component{

  constructor(props) {
    super(props);

    this.state = {
      classware: '',
      feedback: '',
      network: '',
      teacher: '',
      total: '',
    };
  }

  changeStar = (val, index) => {
    this.setState({
      [index]: val
    })
  }

  changeText = (e) => {
    this.setState({
      feedback: e.target.value
    })
  }

  submitEvaluate = () => {
    const { data, refreshData, handleCancel } = this.props;
    const { total, teacher, network, feedback, classware } = this.state;
    if (!total || !teacher || !network || !feedback || !classware) {
      Message.error('请填写评价内容再提交');
      return;
    }
    evaluate({
      student_id: data.get('student_id'),
      schedule_id: data.get('id'),
      result: {
        score: {
          total: total,
          teacher: { total: teacher },
          netword: { total: network },
          classware: { total: classware },
        },
        feedback: feedback,
      }
    }).then(res => {
      if (res.code === 200) {
        Message.success('评价成功');
        refreshData();
        handleCancel();
        return
      }
      Message.error(res.tip);
    })
  }

  star = (i) => {
    return (
      <div className='content-item' key={i}>
        <span className='contentName'>{name[i].name}：</span> 
        <Rate defaultValue={0} onChange={(val) => this.changeStar(val, name[i].type)}/>
      </div>
    )
  }

  render() {
    return (
      <div>
        {[0,0,0,0].map((item, index) => {
          return this.star(index);
        })}
        <div className='content-item flex'>
          <span className='contentName'>意见与建议：</span> 
          <TextArea style={{resize: 'none'}} onChange={(e) => this.changeText(e)} rows={4} resize="false"/>
        </div>
        <div className='dialog-btn'>
          <Button className='confirmbtn' onClick={() => this.submitEvaluate()}>确 定</Button>
        </div>
      </div>
    )
  }
}

export default Evaluate;


// WEBPACK FOOTER //
// ./src/components/dialog/evaluate.jsx